import { render, staticRenderFns } from "./QuestionSteps.vue?vue&type=template&id=35970f56&scoped=true"
import script from "./QuestionSteps.vue?vue&type=script&lang=ts"
export * from "./QuestionSteps.vue?vue&type=script&lang=ts"
import style0 from "./QuestionSteps.vue?vue&type=style&index=0&id=35970f56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35970f56",
  null
  
)

export default component.exports